<template>
<i-dropdown @open="resetSearch">
  <template v-slot:trigger="{toggle, attrs}">
    <button
      @click.prevent="toggle"
      :title="LANG.addOrRemoveFiltersOption"
      class="i-button i-secondary-btn i-button-square"
      v-bind="attrs">+</button>
  </template>

  <template v-slot:default="dropdown">
    <div
      class="dropdown-menu i-dropdown-menu block pull-right"
      style="margin-top: 2px;"
      role="menu"
    >
      <div class="pa2 pb1">
      <SearchText
        v-model="searchTerm"
        ref="searchInputRef"
        autocomplete="off"
        :placeholder="LANG.searchFilters"
        role="combobox"
        :aria-label="LANG.searchFilters"
        aria-controls="list-filters"
        aria-autocomplete="list"
        class="fts-as-you-type"
        />
      </div>
      <ul
        v-if="sortedFilters.length"
        role="presentation"
        id="list-filters"
        tabindex="-1"
        aria-multiselectable="true"
        style="max-height: 350px; overflow-y: auto; min-height: 83px;">
          <li v-for="filter in sortedFilters"
            :key="filter.name"
            @click.prevent="() => toggleFilter(filter, dropdown)"
            @keydown.enter.stop.prevent="() => toggleFilter(filter, dropdown)"
            role="option"
            tabindex="0"
            class="ph2"
            :aria-label="filter.label">
            <i class="fa5" :class="filter.active ? 'fas fa-check-square': 'far fa-square gray'" name="check-square"></i>
            <span class="f5 pl1 va-middle">{{ filter.label }}</span>
          </li>
      </ul>
      <div
        class="no-results"
        v-else>{{ LANG.noResultsMatched }} "{{ searchTerm }} "
      </div>

      <div class="button_container mv1 ph2">
        <button
          @click="() => clearFilters(dropdown)"
          @keydown.enter.stop.prevent="() => clearFilters(dropdown)"
          :title="LANG.clear"
          class="btn i-button i-secondary-btn" >{{ LANG.clear }}</button>
        <button
          @click="dropdown.close"
          @keydown.enter.stop.prevent="dropdown.close"
          :title="LANG.close"
          class="btn i-button" >{{ LANG.close }}</button>
      </div>
    </div>
  </template>
</i-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserGetters, mapBrowserMutations } from '@/store';
import { ascending } from '@/utils/tools';
import SearchText from '@/components/common/SearchText.vue';

export default {
  components: {
    SearchText,
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  computed: {
    ...mapState(['LANG']),
    ...mapBrowserGetters({
      filters: 'optionalFilterParams',
    }),
    filterNames() {
      return this.filters.map((f) => f.name);
    },
    sortedFilters() {
      return [...this.filters]
        .filter((f) => f.label.toLowerCase().includes(this.searchTerm.toLowerCase()))
        // .sort((a, b) => ascending(a.label, b.label))
        .sort((a, b) => ascending(!a.active, !b.active));
    },
  },
  methods: {
    ...mapBrowserMutations([
      'disableFilterParams',
      'enableFilterParam',
      'disableFilterParam',
    ]),
    resetSearch() {
      this.searchTerm = '';

      const { searchInputRef } = this.$refs;
      if (searchInputRef) {
        searchInputRef.focus();
      }
    },
    clearFilters(dropdown) {
      this.disableFilterParams({
        filterNames: this.filterNames,
      });
      dropdown.close();
    },
    toggleFilter(filter, dropdown) {
      const { name, active } = filter;
      if (active) {
        this.disableFilterParam({ name });
      } else {
        this.enableFilterParam({ name, showOptions: true });
      }
      dropdown.close();
    },
  },
};
</script>

<style scoped lang='scss'>
  .i-button-square {
    width: 32px;
    height: 32px;
    font-size: 16px;
    padding: 0;
    margin: 0;
    i.fa5 {
      margin: 0;
    }
  }
  .fa5.gray {
    color: $gray;
  }
  .dropdown-menu {
    min-width: 250px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.18);
  }
  .dropdown-menu li {
    cursor: pointer;
    line-height: 25px;
  }
  .dropdown-menu li:hover {
    text-decoration: none;
    color: #262626;
    background-color: #f5f5f5;
  }
  .no-results {
    padding: 10px;
    background: #f5f5f5;
    margin: 0 10px;
    overflow: hidden;
    max-width: 250px;
    white-space: nowrap;
  }

  .button_container .i-button {
    margin-left: 10px;
    margin-right: 0;
  }
</style>
